import { HttpBackend, HttpEvent, HttpEventType, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentService } from '@util/environment';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CpUserResponse } from '../../interfaces/user-response.interface';

// eslint-disable-next-line @typescript-eslint/naming-convention
const CLIENT_TYPE_HEADERS: Record<string, string> = { 'X-Client-Type': 'mobile' };

@Injectable({
  providedIn: 'root',
})
export class AuthUsermanagementDataService {
  private readonly http: HttpBackend = inject(HttpBackend);
  private readonly env: EnvironmentService = inject(EnvironmentService);

  login$(username: string, password: string, token?: string): Observable<CpUserResponse> {
    return this.http
      .handle(
        new HttpRequest(
          'POST',
          `${this.env.environment.api.usermanagement}/login`,
          { username, password, ...(token ? { token } : {}) },
          // eslint-disable-next-line @typescript-eslint/naming-convention
          { headers: new HttpHeaders({ 'Accept-Version': '2', ...CLIENT_TYPE_HEADERS }) },
        ),
      )
      .pipe(
        filter((event: HttpEvent<CpUserResponse>) => event.type === HttpEventType.Response),
        map((response: HttpEvent<CpUserResponse>) => (response as HttpResponse<CpUserResponse>).body as CpUserResponse),
      );
  }

  refresh$(): Observable<CpUserResponse> {
    return this.http
      .handle(
        new HttpRequest(
          'POST',
          `${this.env.environment.api.usermanagement}/refresh`,
          {},
          { headers: new HttpHeaders(CLIENT_TYPE_HEADERS) },
        ),
      )
      .pipe(
        filter((event: HttpEvent<CpUserResponse>) => event.type === HttpEventType.Response),
        map((response: HttpEvent<CpUserResponse>) => (response as HttpResponse<CpUserResponse>).body as CpUserResponse),
      );
  }
}
